<template lang="pug">
  .student-progress
    v-sheet.units-column
      v-skeleton-loader(
        v-if="loading.courses"
        type="list-item@3"
      )
      v-list(
        v-if="!selectedCourse"
      )
        v-list-item(v-if="!loading.courses && !courses.length")
          v-list-item-subtitle Курсы не найдены...
        v-list-item-group(
          v-model="selectedCourse"
        )
          v-list-item(
            v-for="(course, idx) in courses"
            :key="idx"
            :value="course"
            :disabled="!course.my_active_prior_records_30.length"
          )
            v-list-item-avatar
              v-avatar(color="secondary")
                strong.white--text {{ idx + 1 }}
            v-list-item-content
              v-list-item-title.pre-wrap {{ course.title }}
              v-list-item-subtitle(v-if="course.my_active_prior_records_30.length")
                span Наборов - {{ course.my_active_prior_records_30.length }}
              v-list-item-subtitle(v-else)
                span Доступных наборов нет

        lazy-load(
          v-model="loadMore"
          @on-response="({ items }) => courses.push(...items)"
        )

    template(v-if="selectedCourse")
      v-list
        v-list-item(
          class="grey lighten-4"
          @click="selectedEnrollment = null"
        )
          v-list-item-content.mr-n10.text-center
            v-list-item-title.pre-wrap {{ selectedCourse.title }}
            v-list-item-subtitle
              span Наборов - {{ selectedCourse.my_active_prior_records_30.length }}
          v-list-item-avatar
            v-btn(
              fab
              @click.stop="selectedCourse = null"
            )
              v-icon mdi-close

      v-row
        v-col
          .mt-2 Наборы
          v-sheet.units-column
            v-skeleton-loader(
              v-if="loading.enrollments"
              type="list-item@3"
            )
            v-list(v-else)
              v-list-item(
                v-for="enrollment in selectedCourse.my_active_prior_records_30"
                :key="enrollment.id"
                :class="{ active: selectedEnrollment === enrollment }"
                @click="selectedEnrollment = enrollment"
              ).mb-2
                v-list-item-avatar
                  v-avatar(
                    color="secondary lighten-1"
                  ).caption.white--text {{ enrollment.code }}
                v-list-item-content
                  v-list-item-title
                    | {{ enrollment.start_learning | dp('d MMMM y') }} -
                    |  {{ enrollment.end_learning | dp('d MMMM y') }}
                    .caption.opacity Период обучения
</template>

<script>
export default {
  props: {
    getCoursesMethod: { type: Function, required: true },
  },
  data() {
    return {
      courses: [],
      loadMore: null,
      enrollments: [],

      selectedCourse: null,
      selectedEnrollment: null,

      loading: {
        courses: true,
        enrollments: false,
      },
    };
  },
  watch: {
    selectedCourse() {
      this.selectedEnrollment = null;
    },
    selectedEnrollment(val) {
      this.$emit('input', val);
    },
  },
  created() {
    this.fetchCourses();
  },
  methods: {
    async fetchCourses() {
      this.loading.courses = true;
      const { items, loadMore } = await this.getCoursesMethod();
      this.courses = items;
      this.loadMore = loadMore;
      this.loading.courses = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/mixins';

.units-column {
  @include sdo-dark-scrollbar();

  max-height: calc(100vh - 350px);
  overflow-y: scroll;
}

.active {
  background-color: $secondary-color;

  .v-list-item__content {

    .v-list-item__title {
      color: white;
    }
    .v-list-item__subtitle {
      color: rgba(255,255,255, 0.6);
    }
  }
}
</style>
